export const constantTypes = {
  GET_PROCESSING_STATUSES_REQUEST: "GET_PROCESSING_STATUSES_REQUEST",
  GET_PROCESSING_STATUSES_SUCCESS: "GET_PROCESSING_STATUSES_SUCCESS",
  GET_PROCESSING_STATUSES_FAILURE: "GET_PROCESSING_STATUSES_FAILURE",

  GET_PROCESSING_ERRORS_REQUEST: "GET_PROCESSING_ERRORS_REQUEST",
  GET_PROCESSING_ERRORS_SUCCESS: "GET_PROCESSING_ERRORS_SUCCESS",
  GET_PROCESSING_ERRORS_FAILURE: "GET_PROCESSING_ERRORS_FAILURE",

  GET_PRODUCT_FILE_TYPES_REQUEST: "GET_PRODUCT_FILE_TYPES_REQUEST",
  GET_PRODUCT_FILE_TYPES_SUCCESS: "GET_PRODUCT_FILE_TYPES_SUCCESS",
  GET_PRODUCT_FILE_TYPES_FAILURE: "GET_PRODUCT_FILE_TYPES_FAILURE",
};
